export const checkEmail = (email) => {
  const re = new RegExp(/^.+@.+\..+$/);

  return re.test(email);
};

export default checkEmail;
